// extracted by mini-css-extract-plugin
export default {"cta":"YF-z","disabled":"ZF-z"};